import { useState } from "react";

/**
 * Hook to handle the state of the AddOnDetailModal.
 *
 * @returns {Object} The state of the AddOnDetailModal.
 * @property {Number} scoreIndex - The index of the score to display.
 * @property {Function} handleOpen - The function to open the modal.
 * @property {Function} onClose - The function to close the modal.
 * @property {Function} onPaginate - The function to paginate the scores.
 */
export function useAddOnModal() {
  const [scoreIndex, setScoreIndex] = useState(-1);

  function handleOpen(evt) {
    const scoreIndex = parseInt(
      evt?.currentTarget?.getAttribute?.("data-score-index"),
      10
    );

    if (typeof scoreIndex !== "number" || isNaN(scoreIndex)) {
      return;
    }
    setScoreIndex(scoreIndex);
  }

  function onClose() {
    setScoreIndex(-1);
  }

  function onPaginate(index) {
    const isNext = index === 1;

    setScoreIndex((prevIndex) => {
        const newIndex = prevIndex + (isNext ? 1 : -1);
        return newIndex;
    });
  }

  return {
    scoreIndex,
    handleOpen,
    onClose,
    onPaginate,
  };
}
